<template>
  <div class="pt16">
    <!-- information 隐藏字段用于整体非空校验 -->
    <el-form-item label="" prop="information" ref="information">
      <!-- 表头 -->
      <el-row class="tableHead" :gutter="0">
        <el-col :span="colSpan.type">
          <div class="enbr">{{ $t("enroll.intitle.stock") }}</div>
        </el-col>
        <el-col :span="colSpan.quantity">
          <div class="enbr">{{ $t("enroll.intitle.ratio") }}</div>
        </el-col>
        <el-col :span="colSpan.paidUp" v-if="!isMalaysia">
          <div class="enbr">{{ $t("enroll.intitle.capital") }}</div>
        </el-col>
        <el-col :span="colSpan.paidIn">
          <div class="enbr">{{ paidInCapitalText }}</div>
        </el-col>
        <el-col :span="colSpan.hold" v-if="!isMalaysia">
          <div class="enbr">{{ $t("enroll.intitle.hold") }}</div>
        </el-col>
        <el-col :span="colSpan.trust" v-if="!isMalaysia">
          <div class="enbr">{{ $t("enroll.intitle.trust") }}</div>
        </el-col>
      </el-row>
      <!-- 数据行 -->
      <el-row class="tableItem" v-for="(item, index) of innerForm.sharesInfo" :key="index" :gutter="10">
        <!-- 股票类型 -->
        <el-col :span="colSpan.type">
          <el-form-item :prop="`sharesInfo[${index}].typeOfShares`" class="wdb100">
            <el-select v-model="item.typeOfShares" :placeholder="$t('common.placeholder.select')" class="wdb100">
              <el-option v-for="sItem in globalFormatList('stockList')" :key="`stock-${index}-${sItem.value}`" :label="sItem.label" :value="sItem.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 所占股份数量 - 必填 -->
        <el-col :span="colSpan.quantity">
          <el-form-item
            :prop="`sharesInfo[${index}].quantityOfSharesAllotted`"
            :rules="[{ required: true, message: $t('common.placeholder.enter'), trigger: 'submit' }]"
            class="wdb100"
          >
            <el-input v-model="item.quantityOfSharesAllotted" v-positiveInteger :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
          </el-form-item>
        </el-col>
        <!-- 注册资本 - 必填 (马来西亚隐藏) -->
        <el-col :span="colSpan.paidUp" v-if="!isMalaysia">
          <el-form-item
            :prop="`sharesInfo[${index}].amountOfPaidUpShareCapital`"
            :rules="[{ required: true, validator: validateCurrencyAmount, trigger: 'submit' }]"
            class="wdb100"
          >
            <currency-amount v-model="item.amountOfPaidUpShareCapital" class="wdb100" />
          </el-form-item>
        </el-col>
        <!-- 实收资本 - 必填 -->
        <el-col :span="colSpan.paidIn">
          <el-form-item
            :prop="`sharesInfo[${index}].amountOfPaidInShareCapital`"
            :rules="[{ required: true, validator: validatePaidInCapitalAmount, trigger: 'submit' }]"
            class="wdb100"
          >
            <currency-amount
              v-model="item.amountOfPaidInShareCapital"
              :placeholder="isMalaysia ? $t('enroll.intitle.malaysia.paidInCapitalMax') : ''"
              class="wdb100"
            />
          </el-form-item>
        </el-col>
        <!-- 以信托方式持有股份 - 必填 (马来西亚隐藏) -->
        <el-col :span="colSpan.hold" v-if="!isMalaysia">
          <div class="wdb100 tac holdWrap">
            <el-form-item
              :prop="`sharesInfo[${index}].sharesHoldInTrust`"
              :rules="[{ required: true, message: $t('common.placeholder.select'), trigger: 'submit' }]"
              class="wdb100"
            >
              <el-radio-group v-model="item.sharesHoldInTrust">
                <el-radio :label="1">{{ $t("common.yes") }}</el-radio>
                <el-radio :label="0">{{ $t("common.no") }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </el-col>
        <!-- 信托名称（若适用） - 条件必填（当"以信托方式持有股份"选中"是"时必填） (马来西亚隐藏) -->
        <el-col :span="colSpan.trust" class="customElCol" v-if="!isMalaysia">
          <el-form-item
            :prop="`sharesInfo[${index}].nameOfTheTrust`"
            :rules="item.sharesHoldInTrust ? [{ required: true, message: $t('common.placeholder.enter'), trigger: 'submit' }] : []"
            class="wdb100"
          >
            <el-input v-model="item.nameOfTheTrust" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1" v-if="!isReadonly">
          <el-button type="text" icon="red fs22 el-icon-delete" @click="handleDelete(index)"></el-button>
        </el-col>
      </el-row>
    </el-form-item>
    <div class="fxRow addCompanyWrap" v-if="!isReadonly">
      <el-button type="text" class="fxVer" @click="handleAdd">
        <span class="fs18 vam el-icon-circle-plus-outline"></span>
        <span class="vam ml0">{{ $t("common.button.addMore") }}</span>
      </el-button>
    </div>
  </div>
</template>

<script>
import validatorMixin from "@/mixins/validatorMixin";
import { mapGetters, mapState } from "vuex";

export default {
  name: "SharesTable",
  mixins: [validatorMixin],
  model: { prop: "value", event: "input" },
  props: {
    isReadonly: {
      type: Boolean,
      default: false,
    },
    /** 是否马来西亚（用于默认选中 MYR 币种） */
    isMalaysia: { type: Boolean, default: false },
    /** 表单对象，支持 v-model */
    value: { type: Object, required: true },
  },
  computed: {
    ...mapGetters("constant", ["globalFormatList"]),
    ...mapState("constant", ["currencyList"]),
    /** 内部表单引用（从 value prop 读取） */
    innerForm() {
      return this.value;
    },
    /** 实收资本列头文案（马来西亚使用专属文案） */
    paidInCapitalText() {
      return this.isMalaysia ? this.$t("enroll.intitle.malaysia.paidInCapital") : this.$t("enroll.intitle.paidInCapital");
    },
    /** 各列宽度（span 合计 + 删除按钮 = 24，铺满整行） */
    colSpan() {
      if (this.isMalaysia) {
        // 马来西亚仅3列：8 + 8 + (7或8) (+删除按钮1) = 24
        return { type: 8, quantity: 8, paidUp: 0, paidIn: 7, hold: 0, trust: 0 };
      }
      // 新加坡保持原有布局：3 + 3 + 5 + 3 + 4 (+删除按钮1)
      return { type: 3, quantity: 3, paidUp: 5, paidIn: 5, hold: 3, trust: 4 };
    },
  },
  methods: {
    /** 同步数据到父组件 */
    emitInput(updatedValue) {
      this.$emit("input", updatedValue || this.value);
    },
    /** 实收资本校验（马来西亚: 金额最大不能超过100） */
    validatePaidInCapitalAmount(rule, value, callback) {
      // 1. 先走通用货币格式校验
      this.validateCurrencyAmount(rule, value, error => {
        if (error) return callback(error);
        // 2. 马来西亚: 校验金额范围为 1~100
        if (this.isMalaysia && value) {
          const amount = Number(String(value).split(" ")[1]);
          if (!Number.isNaN(amount) && (amount < 1 || amount > 100)) {
            return callback(new Error(this.$t("enroll.intitle.malaysia.paidInCapitalMax")));
          }
        }
        callback();
      });
    },
    /** 添加一条股份记录 */
    handleAdd() {
      const stockList = this.globalFormatList("stockList");
      const defaultStock = stockList && stockList.length > 0 ? stockList[0].value : "";
      // 马来西亚默认币种为 MYR，其他取列表第一个
      let defaultCurrency = this.currencyList && this.currencyList.length > 0 ? this.currencyList[0].value : "";
      if (this.isMalaysia) {
        defaultCurrency = "MYR";
      }

      const newItem = {
        typeOfShares: defaultStock,
        quantityOfSharesAllotted: null,
        amountOfPaidInShareCapital: `${defaultCurrency} 1`,
      };
      // 注册资本/信托相关字段为马来西亚隐藏字段(非必填)，不初始化
      if (!this.isMalaysia) {
        newItem.amountOfPaidUpShareCapital = "";
        newItem.sharesHoldInTrust = 0;
        newItem.nameOfTheTrust = null;
      }

      const updated = JSON.parse(JSON.stringify(this.value));
      updated.sharesInfo.push(newItem);
      this.emitInput(updated);
    },
    /** 删除一条股份记录 */
    handleDelete(index) {
      const updated = JSON.parse(JSON.stringify(this.value));
      updated.sharesInfo.splice(index, 1);
      this.emitInput(updated);
    },
  },
};
</script>

<style lang="scss" scoped>
.tableHead {
  background: #f4f8fe;
  text-align: center;
  color: #011a45;
  font-weight: bold;
  height: 50px;

  .el-col {
    height: 100%;

    div {
      font-size: 13px;
      line-height: 16px;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }
}
.tableItem {
  border-bottom: 1px solid #ebeef5;

  .el-col {
    display: flex;
    align-items: center;
    height: 70px;

    ::v-deep {
      .el-form-item {
        margin-bottom: 0px !important;
      }

      .el-form-item__error {
        padding-top: 2px !important;
      }
    }
  }

  .customElCol {
    ::v-deep {
      .el-form-item {
        .el-input {
          input {
            border-color: #dcdfe6 !important;
          }
        }
      }

      .el-form-item.el-form-item.is-error {
        .el-input {
          input {
            border-color: #f56c6c !important;
          }
        }
      }
    }
  }
}

.holdWrap {
  border: 1px solid #dcdfe6;
}

.addCompanyWrap {
  width: 100%;
  height: 40px;
  line-height: 40px;
  margin-top: 20px;
}
</style>
